<template>
  <div class="clientes">
    <h1 class="titulo-card fs-4">Grupos de IP Pool's</h1>
    <div class="form-group card-principal">
      <div class="d-flex justify-content-between">
        <div class="input-group mb-3">
          <button v-on:click="handleAdicionar()" class="btn btn-success">
            <font-awesome-icon :icon="['fas', 'plus']" fixed-width class="me-1"/>Adicionar
          </button>
        </div>

        <div class="input-group mb-3">
          <input
              v-on:keyup.enter="handlePesquisa()"
              type="text"
              class="form-control"
              placeholder="Pesquisar"
              aria-label="Pesquisar"
              aria-describedby="button-addon2">
          <button v-on:click="handlePesquisa()" class="btn btn-outline-secondary" type="button" id="button-addon2">
            <font-awesome-icon :icon="['fas', 'search']" fixed-width class="me-1"/>
          </button>
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <router-link v-bind:to="`/configuracoes/grupos-ip-pool/ip-pools`" class="btn btn-sm btn-primary">
          <font-awesome-icon :icon="['fas', 'list']" fixed-width class="me-1"/>IP Pools
        </router-link>
      </div>
      <div class="d-flex">
        <table class="table table-sm-pc table-striped table-hover">
          <thead>
            <tr>
              <th width="25">#</th>
              <th>Identificação do Grupo</th>
              <th width="130">Destino</th>
              <th width="85">Camada IP</th>
              <th width="110"></th>
            </tr>
            </thead>
            <tbody>
              <tr v-for="poolGroup in listaItens" :key="poolGroup.id">
                <td scope="row">{{poolGroup.id}}</td>
                <td>{{poolGroup.descricao}}</td>
                <td>{{poolGroup.tipo_grupo}}</td>
                <td>{{poolGroup.tipo_ip}}</td>
                <td class="text-end">
                  <button type="button" v-on:click="handleGerenciaPoolGroup(poolGroup)" class="btn btn-primary btn-sm me-1">
                    <font-awesome-icon :icon="['fas', 'cogs']" fixed-width/>
                  </button>
                  <button type="button" v-on:click="handleEditaPoolGroup(poolGroup)" class="btn btn-primary btn-sm me-1">
                    <font-awesome-icon :icon="['fas', 'edit']" fixed-width/>
                  </button>
                  <button type="button" v-on:click="handleRemovePoolGroup(poolGroup)" class="btn btn-danger btn-sm">
                    <font-awesome-icon :icon="['fas', 'times']" fixed-width/>
                  </button>
                </td>

              </tr>
            </tbody>
        </table>
      </div>
      <Paginador v-model="paginador" @change-paginacao="onChangePaginacao"/>

      <!-- modal-edita-grupo-ip-pool -->
      <!-- Button trigger modal -->
      <button type="button" class="d-none" data-bs-toggle="modal" data-bs-target="#modal-edita-grupo-ip-pool" id="btn-modal-edita-grupo-ip-pool-abre">
        Launch
      </button>

      <!-- Modal -->
      <div class="modal fade" id="modal-edita-grupo-ip-pool" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-fullscreen-margin" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 v-if="!modal.data.id" class="modal-title">
                <font-awesome-icon :icon="['fas', 'plus']" fixed-width/>
                Cadastrar novo Grupo de IP-Pool
              </h5>
              <h5 v-if="!!modal.data.id" class="modal-title">
                <font-awesome-icon :icon="['fas', 'pen']" fixed-width/>
                Editando Grupo de IP-Pool
              </h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-12 col-sm-4 col-lg-4">
                  <label class="required">Identificação</label>
                  <input type="text" v-model="modal.data.descricao" class="form-control">
                </div>
                <div class="col-12 col-sm-4 col-lg-4">
                  <label class="required">Destino</label>
                  <select v-model.number="modal.data.tipo_grupo" class="form-select">
                    <option value="undefined" disabled>Selecione</option>
                    <option value="tgDistribuicao">Distribuição</option>
                    <option value="tgBloqueio">Bloqueio</option>
                    <option value="tgNaoAutenticados">Não autenticados</option>
                  </select>
                </div>
                <div class="col-12 col-sm-4 col-lg-4">
                  <label class="required">Camada IP</label>
                  <select v-model.number="modal.data.tipo_ip" class="form-select">
                    <option value="undefined" disabled>Selecione</option>
                    <option value="tiIPv4">IPv4</option>
                    <option value="tiIPv6" disabled>IPv6</option>
                    <option value="tiIPv6PD" disabled>IPv6 prefix delegation</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" id="btn-modal-edita-grupo-ip-pool-fecha">Fechar</button>
              <button type="button"
                  v-if="!modal.data.id"
                  v-on:click="handlemodalCadastrar()"
                  v-bind:disabled="!podeSalvarPoolGroup()"
                  class="btn btn-success">
                Cadastrar
              </button>
              <button type="button"
                  v-if="!!modal.data.id"
                  v-on:click="handlemodalSalvar()"
                  v-bind:disabled="!podeSalvarPoolGroup()"
                  class="btn btn-success">
                Salvar
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- modal-edita-grupo-ip-pool -->

      <!-- modal-gerenciamento-grupo-ip-pool -->
      <!-- Button trigger modal -->
      <button type="button" class="d-none" data-bs-toggle="modal" data-bs-target="#modal-gerenciamento-grupo-ip-pool" id="btn-modal-gerenciamento-grupo-ip-pool-abre">
        Launch
      </button>

      <!-- modal-gerenciamento-grupo-ip-pool -->
      <div class="modal fade" id="modal-gerenciamento-grupo-ip-pool" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-fullscreen-margin" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                <font-awesome-icon :icon="['fas', 'cogs']" fixed-width/>
                Gerenciamento do Grupo de IP-Pool
              </h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <p><b>Identificação: </b><span>{{modalGerenciamento.grupoIPPool.descricao}}</span></p>
              <div class="row">
                <div class="col-12 col-sm">
                  <label class="required">Adicionar Pool</label>
                  <select v-model.number="modalGerenciamento.novoPool.poolID" class="form-select">
                    <option value="undefined" disabled>Selecione</option>
                    <option v-for="pool in modalGerenciamentoPoolsDisponiveis()" :key="pool.id" v-bind:value="pool.id">{{pool.descricao}}</option>
                  </select>
                </div>
                <div class="col-12 col-sm-4 col-md-3 col-lg-2">
                  <label class="required">Prioridade</label>
                  <select v-model.number="modalGerenciamento.novoPool.prio" class="form-select">
                    <option value="undefined" disabled>Selecione</option>
                    <option value="0">0</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                  </select>
                </div>
                <div class="col-12 col-sm-auto text-end align-self-end">
                  <button type="button"
                      v-on:click="handleModalGerenciamentoAdicionar()"
                      v-bind:disabled="!modalGerenciamentoPodeAdicionar()"
                      class="btn btn-outline-primary">
                    Adicionar
                  </button>
                </div>
              </div>
              <table class="table table-sm-pc table-striped table-hover">
                <thead>
                  <tr>
                    <th width="25">#</th>
                    <th>Pool</th>
                    <th width="130">CIDR</th>
                    <th width="50">Prioridade</th>
                    <th width="50"></th>
                  </tr>
                  </thead>
                  <tbody>
                    <tr v-for="pool in modalGerenciamento.data.pools" :key="pool.id">
                      <td scope="row">{{pool.id}}</td>
                      <td>{{descricaoPool(pool.ip_pool_id)}}</td>
                      <td>{{cidrPool(pool.ip_pool_id)}}</td>
                      <td>{{pool.prioridade}}</td>
                      <td class="text-end">
                        <button type="button" v-on:click="handleModalGerenciamentoRemovePool(pool)" class="btn btn-danger btn-sm">
                          <font-awesome-icon :icon="['fas', 'times']" fixed-width/>
                        </button>
                      </td>
                    </tr>
                  </tbody>
              </table>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" id="btn-modal-gerenciamento-grupo-ip-pool-fecha">Fechar</button>
              <button type="button" v-on:click="handleModalGerenciamentoSalvar()" class="btn btn-success">Salvar</button>
            </div>
          </div>
        </div>
      </div>
      <!-- modal-gerenciamento-grupo-ip-pool -->
    </div>
  </div>
</template>

<script>
import Paginador from '@/components/Paginador.vue'
import api from '@/modules/api'
import dialogo from '@/modules/dialogo'
import loading from '@/modules/loading'
import clone from '@/modules/clone'
import model from '@/model'

export default {
  name: 'IPPoolGrupos',
  components: {
    Paginador,
  },
  data() {
    return {
      /** @type {model.paginador} */
      paginador: clone(model.paginador),
      listaItens: [],
      pools: [],
      modal: {
        data: {
          id: undefined,
          descricao: '',
          tipo_grupo: undefined,
          tipo_ip: undefined,
        },
      },
      modalGerenciamento: {
        grupoIPPool: {
          id: undefined,
          descricao: '',
          tipo_grupo: undefined,
          tipo_ip: undefined,
        },
        data: {
          pools: [],
        },
        novoPool: {
          id: undefined,
          poolID: undefined,
          prio: undefined,
        }
      }
    }
  },
  methods: {
    handlePesquisa() {
      loading(true);

      api.get(`/grupos-ip-pool?${this.paginador.requestParams}`).then(res => {
        loading(false);
        this.listaItens = res.data.itens;
        this.paginador.pagina = res.data.paginacao.pagina;
        this.paginador.totalItens = res.data.paginacao.total;
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    onChangePaginacao() {
      this.handlePesquisa();
    },

    handleAdicionar() {
      this.resetmodal();
      this.abreModalCadastroPoolGroup();
    },

    async handleEditaPoolGroup(poolGroup) {
      this.resetmodal();

      this.modal.data = clone(poolGroup);

      this.abreModalCadastroPoolGroup();
    },

    handleGerenciaPoolGroup(poolGroup) {
      this.modalGerenciamento.grupoIPPool = clone(poolGroup);

      this.abreModalGerenciaPoolGroup();
    },

    handleRemovePoolGroup(poolGroup) {
      dialogo.confirmacao(`Confirma remover o Grupo <b>${poolGroup.descricao}</b>?`).then(() => {
        loading(true);

        api.delete(`/grupos-ip-pool/${poolGroup.id}`).then(() => {
          loading(false);

          this.handlePesquisa();
        }).catch(error => {
          loading(false);
          dialogo.erroHttp(error);
        });
      });
    },

    abreModalCadastroPoolGroup() {
      document.getElementById('btn-modal-edita-grupo-ip-pool-abre').click();
    },

    resetmodal() {
      this.modal.data.id = undefined;
      this.modal.data.descricao = '';
      this.modal.data.tipo_grupo = undefined;
      this.modal.data.tipo_ip = undefined;
    },

    podeSalvarPoolGroup() {
      switch (true) {
        case (this.modal.data.descricao.length < 3):
        case (undefined === this.modal.data.tipo_grupo):
        case (undefined === this.modal.data.tipo_ip):
          return false;

        default:
          return true;
      }
    },

    handlemodalCadastrar() {
      const sendData = {...this.modal.data};

      loading(true);

      api.post('/grupos-ip-pool', sendData).then(() => {
        loading(false);
        document.getElementById('btn-modal-edita-grupo-ip-pool-fecha').click();
        this.handlePesquisa();
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    handlemodalSalvar() {
      const sendData = {...this.modal.data};

      sendData.nome = sendData.razao_social;

      loading(true);
      api.put(`/grupos-ip-pool/${sendData.id}`, sendData).then(() => {
        loading(false);
        document.getElementById('btn-modal-edita-grupo-ip-pool-fecha').click();
        this.handlePesquisa();
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },



    //modal-gerenciamento-grupo-ip-pool
    modalGerenciamentoReset() {
      this.modalGerenciamento.novoPool.id = undefined;
      this.modalGerenciamento.novoPool.poolID = undefined;
      this.modalGerenciamento.novoPool.prio = undefined;
    },

    async abreModalGerenciaPoolGroup() {
      const poolID = this.modalGerenciamento.grupoIPPool.id;
      const apiUrl = `/grupos-ip-pool/${poolID}/ip-pools`;
      var houveErro = false;

      this.modalGerenciamentoReset();
      loading(true);

      await api.get(`/ip-pools?paginacao.porPagina=-1`).then(res => {
        this.pools = res.data.itens;
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
        houveErro = true;
      });

      if (houveErro) {
        return;
      }

      await api.get(apiUrl).then(res => {
        loading(false);
        this.modalGerenciamento.data.pools = res.data;
        document.getElementById('btn-modal-gerenciamento-grupo-ip-pool-abre').click();
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    fechaModalGerenciamentoPoolGroup() {
      document.getElementById('btn-modal-gerenciamento-grupo-ip-pool-fecha').click();
    },

    poolByID(id) {
      return this.pools.find(pool => pool.id === id);
    },

    descricaoPool(id) {
      const pool = this.poolByID(id);

      return (pool) ? pool.descricao : '-';
    },

    cidrPool(id) {
      const pool = this.poolByID(id);

      return (pool) ? pool.cidr : '-';
    },

    modalGerenciamentoPodeAdicionar() {
      switch (true) {
        case (!this.modalGerenciamento.novoPool.poolID):
        case (undefined === this.modalGerenciamento.novoPool.prio):
          return false;

        default:
          return true;
      }
    },

    handleModalGerenciamentoAdicionar() {
      const pool = {
        id: undefined,
        grupo_ip_pool_id: this.modalGerenciamento.grupoIPPool.id,
        ip_pool_id: this.modalGerenciamento.novoPool.poolID,
        prioridade: this.modalGerenciamento.novoPool.prio,
      };

      this.modalGerenciamento.data.pools.push(pool);
      this.modalGerenciamentoReset();
    },

    modalGerenciamentoPoolsDisponiveis() {
      const tipoGrupo = this.modalGerenciamento.grupoIPPool.tipo_grupo;
      const tipoIP = this.modalGerenciamento.grupoIPPool.tipo_ip;
      const existentesID = this.modalGerenciamento.data.pools.map(x => x.ip_pool_id);

      return this.pools.filter(x => {
        return (tipoGrupo === x.tipo_grupo &&
            tipoIP === x.tipo_ip &&
            !existentesID.includes(x.id));
      });
    },

    handleModalGerenciamentoRemovePool(pool) {
      const indice = this.modalGerenciamento.data.pools.indexOf(pool);

      if (indice < 0) {
        return;
      }

      this.modalGerenciamento.data.pools.splice(indice, 1);
    },

    handleModalGerenciamentoSalvar() {
      dialogo.confirmacao(`Confirma <b>salvar</b> as alterações?`).then(() => {
        const poolID = this.modalGerenciamento.grupoIPPool.id;
        const sendData = this.modalGerenciamento.data.pools;
        const apiUrl = `/grupos-ip-pool/${poolID}/ip-pools`;

        loading(true);

        api.put(apiUrl, sendData).then(() => {
          loading(false);
          dialogo.alerta('As informações foram salvas com sucesso.');
          this.fechaModalGerenciamentoPoolGroup();
        }).catch(error => {
          loading(false);
          dialogo.erroHttp(error);
        });
      });
    }
    //modal-gerenciamento-grupo-ip-pool
  },

  created() {
    this.handlePesquisa();
  }
}
</script>
